"use client";

import { createContext } from "react";

/**
 * When the server rendered the document (the root loader's `renderedAt`). Relative times hydrate
 * against it (`useRelativeTime`), so the browser's first render matches the server HTML. It never
 * changes: updating a context above a part of the page that is still hydrating makes React discard
 * that part's server HTML and render it again, which blinks server-component content.
 */
export const RenderedAtContext = createContext<number | undefined>(undefined);
